import React, { useRef, useEffect, useState } from 'react';

const ProductThumbnailVideo = ({ 
  posterImage,
  autoPlay = true,
  muted = true,
  loop = true,
  overlay = true,
  padding = '40px 20px',
  borderRadius = '24px',
  containerMaxWidth = 'auto',
  containerHeight = '70vh',
  backgroundColor = '#f5f5f5'
}) => {
  const videoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasVideo, setHasVideo] = useState(false);

  useEffect(() => {
    fetch('https://evercorenutrition.com/ev_admin/api/videos/active/')
      .then(res => res.json())
      .then(data => {
        // Check if data exists and has items
        if (data && Array.isArray(data) && data.length > 0) {
          setVideoSrc(data[0].video_url);
          setHasVideo(true);
        } else {
          setHasVideo(false);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch video:', err);
        setHasVideo(false);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (videoRef.current && autoPlay && videoSrc) {
      videoRef.current.play().catch(err => {
        console.log('Autoplay prevented:', err);
      });
    }
  }, [autoPlay, videoSrc]);

  // Don't render anything if no video (either empty response or error)
  if (!hasVideo) {
    return null;
  }

  // Show loading state while fetching (optional - you can remove this if you want)
  if (loading) {
    return null; // Or show a loading spinner if preferred
  }

  return (
    <section className="blog-section" style={{ backgroundColor: '#f5f5f5' }}>
      <div className="container-fluid-lg">
        <div className="title d-block">
          <h2>Discover how our amazing products making proccess</h2>
          <span className="title-leaf">
            <svg className="icon-width">
              <use href="../assets/svg/leaf.svg#leaf"></use>
            </svg>
          </span>
          <p>From workouts to workdays, Evercore fits into real lives.</p>
        </div>
      </div>

      <div style={{
        position: 'relative',
        width: '100%',
        padding: padding,
        backgroundColor: backgroundColor,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{
          position: 'relative',
          width: '100%',
          maxWidth: containerMaxWidth,
          height: containerHeight,
          borderRadius: borderRadius,
          overflow: 'hidden',
          boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
        }}>
          {videoSrc && (
            <video
              ref={videoRef}
              src={videoSrc}
              poster={posterImage}
              autoPlay={autoPlay}
              muted={muted}
              loop={loop}
              playsInline
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                backgroundColor: '#000000'
              }}
            />
          )}

          {overlay && (
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'linear-gradient(135deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.2) 100%)',
              pointerEvents: 'none',
              zIndex: 1
            }} />
          )}
        </div>
      </div>
    </section>
  );
};

export default ProductThumbnailVideo;